var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 27V13C29 11.9 28.1 11 27 11H13C11.9 11 11 11.9 11 13V27C11 28.1 11.9 29 13 29H27C28.1 29 29 28.1 29 27ZM16.5 21.5L19 24.51L22.5 20L27 26H13L16.5 21.5Z",
    fill: "#9DA5BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarFallback);
export default __webpack_public_path__ + "static/media/avatar-fallback.a423e03970c177d0eb67aff3628ff82c.svg";
export { ForwardRef as ReactComponent };